import { useEffect, useState } from "react";
import classNames from "classnames";
import {
  dismissToast,
  subscribeToasts,
  type ToastItem,
} from "./toast-store";

const Toast = ({ toast }: { toast: ToastItem }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setIsVisible(true));
  }, []);

  return (
    <div
      className={classNames(
        "flex items-center gap-2 px-4 py-2 rounded-lg shadow-lg border-2 max-w-[90vw] transition-all duration-300 pointer-events-auto",
        {
          "bg-pk-green-4 border-pk-green-5": toast.variant === "success",
          "bg-pk-red-4 border-pk-red-5": toast.variant === "error",
          "opacity-100 translate-y-0": isVisible,
          "opacity-0 -translate-y-2": !isVisible,
        },
      )}
      onClick={() => dismissToast(toast.id)}
    >
      <span className="text-sm">
        {toast.variant === "success" ? "✅" : "⚠️"}
      </span>
      <span className="font-medium text-white text-sm">{toast.message}</span>
    </div>
  );
};

export const ToastContainer = () => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => subscribeToasts(setToasts), []);

  if (toasts.length === 0) return null;

  return (
    <div className="top-4 left-1/2 z-[60] fixed flex flex-col items-center gap-2 pointer-events-none -translate-x-1/2">
      {toasts.map((item) => (
        <Toast key={item.id} toast={item} />
      ))}
    </div>
  );
};
